export default __webpack_public_path__ + "static/google-reviews-68d71282e8c1f538c2c577cff0bd1744.svg";